var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "../api";
var AutomationService = /** @class */ (function () {
    function AutomationService() {
    }
    /**
     * The template catalogue, already built in one language and already laid out: `title`,
     * `description` and every node label come back as display copy, not as i18n keys, and every node
     * carries the position it will have on the canvas. Without `language` the API falls back to the
     * caller's own interface language; anything that is not German comes back in English.
     */
    AutomationService.getTemplates = function (domain, language) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, api.get("".concat(AutomationService.baseUrl, "/templates"), {
                            params: { domain: domain, language: language }
                        })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, (_a = response.data) !== null && _a !== void 0 ? _a : []];
                }
            });
        });
    };
    /**
     * Creates the flow a template describes and returns it saved as a DRAFT — node ids, positions,
     * the domain and any audience the template needs are all the API's work. Answers 404 for a key
     * that is not in the catalogue.
     */
    AutomationService.instantiateTemplate = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/templates/instantiate"), request)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.getFlows = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new URLSearchParams();
                        if (filters === null || filters === void 0 ? void 0 : filters.status)
                            params.append('status', filters.status);
                        if (filters === null || filters === void 0 ? void 0 : filters.domain)
                            params.append('domain', filters.domain);
                        if ((filters === null || filters === void 0 ? void 0 : filters.page) != null)
                            params.append('page', filters.page.toString());
                        if (filters === null || filters === void 0 ? void 0 : filters.pageSize)
                            params.append('size', filters.pageSize.toString());
                        if (filters === null || filters === void 0 ? void 0 : filters.searchTerm)
                            params.append('search', filters.searchTerm);
                        if (filters === null || filters === void 0 ? void 0 : filters.sortBy)
                            params.append('sort', "".concat(filters.sortBy, ",").concat(filters.sortDir || 'ASC'));
                        return [4 /*yield*/, api.get("".concat(AutomationService.baseUrl, "/flows?").concat(params.toString()))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.getFlow = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("".concat(AutomationService.baseUrl, "/flows/").concat(id))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.createFlow = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/flows"), data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.updateFlow = function (id, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.put("".concat(AutomationService.baseUrl, "/flows/").concat(id), data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.deleteFlow = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.delete("".concat(AutomationService.baseUrl, "/flows/").concat(id))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Rebuilds a flow written against the retired node types (Loop, Get Profile, inline audience
     * filters) as a new DRAFT copy — "<original> (migrated)" — carrying `migrationNotes` for
     * everything a human still has to check. The original is left exactly as it is. The API answers
     * 400 when the flow has nothing to migrate.
     */
    AutomationService.migrateFlow = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/flows/").concat(id, "/migrate"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.activateFlow = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/flows/").concat(id, "/activate"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.pauseFlow = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/flows/").concat(id, "/pause"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /** Queues a test run and returns the queued execution, so the editor can poll it and narrate its steps. */
    AutomationService.triggerFlow = function (id, options) {
        return __awaiter(this, void 0, void 0, function () {
            var triggerData, triggerNode, testRecipient, entityId, memberIds, memberNodeId, chosen, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        triggerData = options.triggerData, triggerNode = options.triggerNode, testRecipient = options.testRecipient, entityId = options.entityId, memberIds = options.memberIds, memberNodeId = options.memberNodeId;
                        chosen = (memberIds === null || memberIds === void 0 ? void 0 : memberIds.length) ? memberIds : undefined;
                        return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/flows/").concat(id, "/trigger"), triggerData, {
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                // One comma-joined value: `api` sets no params serializer, and axios would otherwise send
                                // `memberIds[]=…`, which the API's plain request parameter does not bind.
                                params: {
                                    triggerNode: triggerNode,
                                    testRecipient: testRecipient,
                                    entityId: entityId,
                                    memberIds: chosen === null || chosen === void 0 ? void 0 : chosen.join(','),
                                    memberNodeId: chosen ? memberNodeId : undefined
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /** Runs an active automation once from the selected manual trigger, for its real recipients. */
    AutomationService.runManualTrigger = function (id, triggerNode) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/flows/").concat(id, "/trigger"), undefined, {
                            params: { triggerNode: triggerNode, live: true }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * "Who gets it?": what the flow would do if it ran now — read-only, nothing is saved or sent.
     * `canvas` is the editor's current graph, unsaved changes included; without it the stored flow is
     * previewed. A flow without a trigger comes back `unsupported: 'NO_TRIGGER'`; one started by an
     * event previews as 0 "right now" (an event has no "now").
     */
    AutomationService.previewFlow = function (id, canvas, triggerNode) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/flows/").concat(id, "/preview"), canvas, {
                            params: { triggerNode: triggerNode }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /** The entities a manual run of this flow can be built from, newest first. Empty for a manual or scheduled trigger. */
    AutomationService.getTriggerCandidates = function (id, limit) {
        var _a;
        if (limit === void 0) { limit = 20; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, api.get("".concat(AutomationService.baseUrl, "/flows/").concat(id, "/trigger-candidates"), {
                            params: { limit: limit }
                        })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, (_a = response.data) !== null && _a !== void 0 ? _a : []];
                }
            });
        });
    };
    AutomationService.getExecutions = function (filters) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var params, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        params = new URLSearchParams();
                        params.append('sort', "".concat((_a = filters === null || filters === void 0 ? void 0 : filters.sortBy) !== null && _a !== void 0 ? _a : 'insertDate', ",").concat((_b = filters === null || filters === void 0 ? void 0 : filters.sortDir) !== null && _b !== void 0 ? _b : 'DESC'));
                        if (filters === null || filters === void 0 ? void 0 : filters.flowId)
                            params.append('flowId', filters.flowId);
                        if (filters === null || filters === void 0 ? void 0 : filters.status)
                            params.append('status', filters.status);
                        if (filters === null || filters === void 0 ? void 0 : filters.parentExecutionId)
                            params.append('parentExecutionId', filters.parentExecutionId);
                        if ((filters === null || filters === void 0 ? void 0 : filters.page) != null)
                            params.append('page', filters.page.toString());
                        if ((filters === null || filters === void 0 ? void 0 : filters.pageSize) != null)
                            params.append('size', filters.pageSize.toString());
                        return [4 /*yield*/, api.get("".concat(AutomationService.baseUrl, "/executions?").concat(params.toString()))];
                    case 1:
                        response = _c.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.getExecution = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("".concat(AutomationService.baseUrl, "/executions/").concat(id))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Ends the timed waits a test run is parked at — the run and its member runs — so the steps
     * below run now. Test runs only; a live run, and "Wait for everyone", are refused.
     */
    AutomationService.skipTestWait = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AutomationService.baseUrl, "/executions/").concat(id, "/skip-wait"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.getStatistics = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("".concat(AutomationService.baseUrl, "/statistics"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AutomationService.baseUrl = '/v3/marketing/automations';
    return AutomationService;
}());
export { AutomationService };
